import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faDatabase,
  faComments,
  faBrain,
  faChartSimple,
} from '@fortawesome/free-solid-svg-icons';

export default function HowItWorks() {
  const steps = [
    {
      icon: faDatabase,
      step: 'Step 1',
      title: 'Connect Data',
      desc: 'Connect PostgreSQL, MySQL, SQLite or upload CSV files.',
    },
    {
      icon: faComments,
      step: 'Step 2',
      title: 'Ask Questions',
      desc: 'Ask anything using natural language — no SQL required.',
    },
    {
      icon: faBrain,
      step: 'Step 3',
      title: 'AI Analyzes',
      desc: 'Schema detection, query translation, insight generation.',
    },
    {
      icon: faChartSimple,
      step: 'Step 4',
      title: 'Get Insights',
      desc: 'Receive charts, comparisons, summaries, and recommendations.',
    },
  ];

  return (
    <section id="how" style={s.section}>
      
      {/* Header */}
      <div style={s.header}>
        <h2 style={s.title}>
          How It <span style={s.gradient}>Works</span>
        </h2>
        <p style={s.sub}>
          From raw data to actionable intelligence in four simple steps.
        </p>
      </div>

      {/* Steps */}
      <div style={s.grid}>
        {steps.map((item, i) => (
          <div key={i} style={s.card}>

            <div style={s.iconWrap}>
              <FontAwesomeIcon icon={item.icon} />
            </div>

            <div style={s.step}>{item.step}</div>
            <div style={s.cardTitle}>{item.title}</div>
            <div style={s.desc}>{item.desc}</div>

          </div>
        ))}
      </div>

      {/* Arrows */}
      <div style={s.arrows}>
        <span>→</span>
        <span>→</span>
        <span>→</span>
      </div>

    </section>
  );
}
const s = {
  section: {
    padding: '90px 80px',
    textAlign: 'center',
    background:'linear-gradient(135deg,#eef2ff,#f8fafc)'
  },

  header: {
    marginBottom: 60,
  },

  title: {
    fontSize: 36,
    fontWeight: 800,
    marginBottom: 10,
  },

  gradient: {
    background: 'linear-gradient(135deg,#6366f1,#8b5cf6)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
  },

  sub: {
    color: 'var(--text-muted)',
    fontSize: 15,
  },

  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: 24,
    marginBottom: 30,
  },

  card: {
    padding: '30px 24px',
    borderRadius: 18,
    background: '#fff',
    border: '1px solid rgba(0,0,0,0.05)',
    boxShadow: '0 10px 40px rgba(0,0,0,0.05)',
    transition: 'all 0.25s ease',
  },

  iconWrap: {
    width: 56,
    height: 56,
    borderRadius: 16,
    background: 'linear-gradient(135deg,#6366f1,#8b5cf6)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
    fontSize: 20,
    margin: '0 auto 18px',
  },

  step: {
    fontSize: 12,
    color: '#6366f1',
    fontWeight: 600,
    marginBottom: 6,
  },

  cardTitle: {
    fontSize: 18,
    fontWeight: 700,
    marginBottom: 10,
  },

  desc: {
    fontSize: 14,
    color: 'var(--text-muted)',
    lineHeight: 1.6,
  },

  arrows: {
    display: 'flex',
    justifyContent: 'center',
    gap: 140,
    fontSize: 20,
    color: '#8b5cf6',
    opacity: 0.6,
  },
};